import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { sensibleDefaultBreakpoints } from './lib/breakpoints';
import { generateMediaBreakpoints } from './lib/media';
import { generateTypescale } from './lib/typescale';
import { generateSizeMixin } from './lib/size';
import { generateSpacingMixins } from './lib/spacing';

var initTypescale = function initTypescale() {
  var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sensibleDefaultBreakpoints;
  var media = generateMediaBreakpoints(breakpoints);
  var typescale = generateTypescale(breakpoints);
  var size = generateSizeMixin(breakpoints, typescale, media);

  var _generateSpacingMixin = generateSpacingMixins(breakpoints, media),
      _generateSpacingMixin2 = _slicedToArray(_generateSpacingMixin, 2),
      margin = _generateSpacingMixin2[0],
      padding = _generateSpacingMixin2[1];

  return {
    media: media,
    size: size,
    margin: margin,
    padding: padding
  };
};

export default initTypescale;